import {createApp} from 'vue'
import CollapsibleMobileMenu from './components/CollapseMobileMenu'
import SearchFilter from './components/SearchFilter'
import SearchBar from './components/SearchBar'
import Popover from './components/Popover'
import Carousel from './components/Carousel'
import CardExpander from './components/CardExpander'
import ProgressStatisticIcon from './components/ProgressStatisticIcon'
import mitt from 'mitt'
import './font-awesome'
import {Expander, ExpanderHeader, ExpanderContent} from '@freave/wp-freave-expander'
import {Swiper} from '@freave/photoplayer'

const emitter = mitt()
const app = createApp({})

app.component('Expander', Expander)
app.component('ExpanderContent', ExpanderContent)
app.component('ExpanderHeader', ExpanderHeader)
app.component('Swiper', Swiper)
app.component('CollapseHeaderMobile', CollapsibleMobileMenu)
app.component('SearchFilter', SearchFilter)
app.component('Popover', Popover)
app.component('SearchBar', SearchBar)
app.component('Carousel', Carousel)
app.component('CardExpander', CardExpander)
app.component('ProgressStatisticIcon', ProgressStatisticIcon)
app.config.globalProperties.emitter = emitter
app.mount('#app')
